module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Manifestation Details")])], 1), _vm._v(" "), _c('banner-component', {
    attrs: {
      "allModuleIdBanner": _vm.ffExportDetail.allModuleId ? _vm.ffExportDetail.allModuleId : '',
      "jobSeriesBanner": _vm.ffExportDetail.ffExportFclSeries ? _vm.ffExportDetail.ffExportFclSeries : '',
      "bannerClientName": _vm.ffExportDetail.clientName ? _vm.ffExportDetail.clientName : '',
      "iconId": "fa fa-ship"
    }
  }), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [(_vm.ffExportDetail.allModuleId) ? _c('ContainerTable', {
    attrs: {
      "PMC_JOBID": _vm.ffExportDetail.allModuleId ? Number(_vm.ffExportDetail.allModuleId) : 0,
      "containers": [],
      "showContainerStatus": ''
    },
    on: {
      "status-change": _vm.activateUser
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [(_vm.ManifestationCreated) ? _c('span', {
    staticClass: "error pull-right"
  }, [_c('b', [_vm._v(_vm._s(" " + _vm.ManifestationCreated))]), _c('br')]) : _vm._e()]), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [(_vm.ManifestationUpdated) ? _c('span', {
    staticClass: "error pull-right"
  }, [_c('b', [_vm._v(_vm._s(_vm.ManifestationUpdated))]), _c('br')]) : _vm._e()]), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Type "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.agentTypeList,
      "option-value": "TypeVal",
      "option-text": "TypeTxt",
      "placeholder": "Select Type"
    },
    on: {
      "input": function($event) {
        _vm.getAgentConsigneeList(_vm.AddManifestationDetail.type_of_agent)
      }
    },
    model: {
      value: (_vm.AddManifestationDetail.type_of_agent),
      callback: function($$v) {
        _vm.$set(_vm.AddManifestationDetail, "type_of_agent", $$v)
      },
      expression: "AddManifestationDetail.type_of_agent"
    }
  }), _vm._v(" "), (!_vm.AddManifestationDetail.type_of_agent) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorManifest.type_of_agent))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.AddManifestationDetail.type_of_agent) + "\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.getAllAgentColoaderList.length > 0 ?
        _vm.getAllAgentColoaderList :
        _vm.AddManifestationDetail.type_of_agent == 'Agent' ?
        _vm.$store.getters['common/getAllAgentColoaderList'] :
        _vm.$store.getters['common/getAllConsigneeList'],
      "option-value": "agentName",
      "option-text": "agentName",
      "placeholder": _vm.AddManifestationDetail.type_of_agent == 'Consignee' ?
        'Select Consignee' :
        'Select Agent/Coloader'
    },
    on: {
      "input": function($event) {
        _vm.getConsigneeAgentDetails(_vm.AddManifestationDetail.type_of_agent)
      }
    },
    model: {
      value: (_vm.AddManifestationDetail.AgentColoader),
      callback: function($$v) {
        _vm.$set(_vm.AddManifestationDetail, "AgentColoader", $$v)
      },
      expression: "AddManifestationDetail.AgentColoader"
    }
  }), _vm._v(" "), (_vm.errorManifest.AgentColoader) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorManifest.AgentColoader +
    " " +
    _vm.AddManifestationDetail.type_of_agent))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "Booking No"
    }
  }, [_vm._v("\n                  Booking No\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter Booking No"
    },
    model: {
      value: (_vm.AddManifestationDetail.validBookingNo),
      callback: function($$v) {
        _vm.$set(_vm.AddManifestationDetail, "validBookingNo", $$v)
      },
      expression: "AddManifestationDetail.validBookingNo"
    }
  }), _vm._v(" "), (!_vm.AddManifestationDetail.validBookingNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorManifest.validBookingNo))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "SOB"
    }
  }, [_vm._v("\n                  SOB\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "SOB",
      "minute-step": 1,
      "name": "SOB"
    },
    model: {
      value: (_vm.AddManifestationDetail.SOB),
      callback: function($$v) {
        _vm.$set(_vm.AddManifestationDetail, "SOB", $$v)
      },
      expression: "AddManifestationDetail.SOB"
    }
  }), _vm._v(" "), (!_vm.AddManifestationDetail.SOB) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorManifest.SOB))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "ETADest"
    }
  }, [_vm._v("\n                  ETA Dest\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "ETADest",
      "minute-step": 1,
      "name": "ETADest"
    },
    model: {
      value: (_vm.AddManifestationDetail.ETADest),
      callback: function($$v) {
        _vm.$set(_vm.AddManifestationDetail, "ETADest", $$v)
      },
      expression: "AddManifestationDetail.ETADest"
    }
  }), _vm._v(" "), (!_vm.AddManifestationDetail.ETADest) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorManifest.ETADest))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mt-2"
  }, [_c('table', {
    staticClass: "table table-sm table-bordered"
  }, [_c('tbody', {
    staticStyle: {
      "background": "white"
    }
  }, [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SN.")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Particulars")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5%"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Container Count")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Amount (Accept Only Numbers)")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Currency")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7%"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Final AMT")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Remarks")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                      Action\n                      "), _c('b-button', {
    attrs: {
      "id": "show-btn",
      "size": "sm",
      "variant": "primary"
    },
    on: {
      "click": _vm.addInvArry
    }
  }, [_vm._v("\n                        Add "), _c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)]), _vm._v(" "), _vm._l((_vm.lineADDManifestationModalArray), function(itm, idx) {
    return _c('tr', {
      key: idx
    }, [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(idx + 1))]), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "isDisabled": itm.manifestationId != '' ? true : false,
        "list": _vm.TypeList,
        "option-value": "typeVal",
        "option-text": "typeText",
        "placeholder": "Select Type"
      },
      model: {
        value: (itm.addManifestation_type),
        callback: function($$v) {
          _vm.$set(itm, "addManifestation_type", $$v)
        },
        expression: "itm.addManifestation_type"
      }
    }), _vm._v(" "), (itm.addManifestation_type_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.addManifestation_type_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "isDisabled": itm.manifestationId != '' ? true : false,
        "list": _vm.ParticularList,
        "option-value": "partVal",
        "option-text": "partText",
        "placeholder": "Select Particular"
      },
      model: {
        value: (itm.addManifestation_ledgerId),
        callback: function($$v) {
          _vm.$set(itm, "addManifestation_ledgerId", $$v)
        },
        expression: "itm.addManifestation_ledgerId"
      }
    }), _vm._v(" "), (itm.addManifestation_ledgerId_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.addManifestation_ledgerId_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "id": "container_count",
        "name": "container_count",
        "type": "number"
      },
      on: {
        "input": function($event) {
          _vm.updateAmount(itm)
        },
        "change": function($event) {
          _vm.updateAmount(itm)
        },
        "keyup": _vm.TotalAMT
      },
      model: {
        value: (itm.container_count),
        callback: function($$v) {
          _vm.$set(itm, "container_count", $$v)
        },
        expression: "itm.container_count"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "disabled": itm.manifestationId != '' ? true : false,
        "formatter": _vm.capitalizeAll,
        "id": "amount",
        "name": "amount",
        "type": "number"
      },
      on: {
        "input": function($event) {
          _vm.CheckValueNumbers($event)
        },
        "change": function($event) {
          _vm.CheckValueNumbers($event)
        },
        "keyup": _vm.TotalAMT
      },
      model: {
        value: (itm.addManifestation_amount),
        callback: function($$v) {
          _vm.$set(itm, "addManifestation_amount", $$v)
        },
        expression: "itm.addManifestation_amount"
      }
    }), _vm._v(" "), (itm.addManifestation_amount_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.addManifestation_amount_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "isDisabled": itm.manifestationId != '' ? true : false,
        "list": _vm.CurrencyList,
        "option-value": "currency_id",
        "option-text": "currencyCode",
        "placeholder": "Select Currency"
      },
      model: {
        value: (itm.addManifestation_currency),
        callback: function($$v) {
          _vm.$set(itm, "addManifestation_currency", $$v)
        },
        expression: "itm.addManifestation_currency"
      }
    }), _vm._v(" "), (itm.addManifestation_currency_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.addManifestation_currency_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(itm.final_amt || _vm.getSelectedContList.length * itm.addManifestation_amount))]), _vm._v(" "), _c('td', [_c('b-form-textarea', {
      attrs: {
        "disabled": itm.manifestationId != '' ? true : false,
        "formatter": _vm.capitalizeAll,
        "id": "remark",
        "name": "remark"
      },
      model: {
        value: (itm.addManifestation_remark),
        callback: function($$v) {
          _vm.$set(itm, "addManifestation_remark", $$v)
        },
        expression: "itm.addManifestation_remark"
      }
    }), _vm._v(" "), (itm.addManifestation_remark_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.addManifestation_remark_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b-button', {
      staticClass: "ml-auto",
      attrs: {
        "disabled": itm.manifestationId != '' ? true : false,
        "id": "show-btn",
        "size": "sm",
        "variant": "danger"
      },
      on: {
        "click": function($event) {
          _vm.removeInvArry(idx)
        }
      }
    }, [_vm._v("\n                        Remove\n                        "), _c('i', {
      staticClass: "fa fa-minus",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1)])
  }), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('b', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bold",
      "font-size": "18px"
    }
  }, [_vm._v("Debit Total")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('b', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bold",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.TotDebit))])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('b', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bold",
      "font-size": "18px"
    }
  }, [_vm._v("Credit Total")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('b', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bold",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.TotCredit))])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('b', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bold",
      "font-size": "18px"
    }
  }, [_vm._v("Net Total")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('b', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bold",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.TotAMT))])])])], 2)])]), _vm._v(" "), (!_vm.MBLFlag) ? _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Shipment Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.shipmentTypeList,
      "option-value": "shipmentTypeVal",
      "option-text": "shipmentTypeTxt",
      "placeholder": "Select Shipment Type"
    },
    model: {
      value: (_vm.MBLData.bl_shipment_type),
      callback: function($$v) {
        _vm.$set(_vm.MBLData, "bl_shipment_type", $$v)
      },
      expression: "MBLData.bl_shipment_type"
    }
  }), _vm._v(" "), (!_vm.MBLData.bl_shipment_type) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMBLList.bl_shipment_type))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("B/L Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": true,
      "list": _vm.blTypeList,
      "option-value": "blTypeVal",
      "option-text": "blTypeTxt",
      "placeholder": "Select B/L Type"
    },
    model: {
      value: (_vm.MBLData.blType),
      callback: function($$v) {
        _vm.$set(_vm.MBLData, "blType", $$v)
      },
      expression: "MBLData.blType"
    }
  }), _vm._v(" "), (!_vm.MBLData.blType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMBLList.blType))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Liner Freght Terms")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.frghtTermsLinerListName,
      "option-value": "frghtTermsLinerVal",
      "option-text": "frghtTermsLinerTxt",
      "placeholder": "Select Freght Terms"
    },
    model: {
      value: (_vm.MBLData.frghtTermsLiner),
      callback: function($$v) {
        _vm.$set(_vm.MBLData, "frghtTermsLiner", $$v)
      },
      expression: "MBLData.frghtTermsLiner"
    }
  }), _vm._v(" "), (!_vm.MBLData.frghtTermsLiner) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMBLList.frghtTermsLiner))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("MBL Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "linerBLNumber",
      "name": "linerBLNumber"
    },
    model: {
      value: (_vm.MBLData.linerBLNumber),
      callback: function($$v) {
        _vm.$set(_vm.MBLData, "linerBLNumber", $$v)
      },
      expression: "MBLData.linerBLNumber"
    }
  }), _vm._v(" "), (!_vm.MBLData.linerBLNumber) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMBLList.linerBLNumber))]) : _vm._e()], 1), _vm._v(" "), (_vm.MBLData.bl_shipment_type !== 'NOMINATION') ? _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('label', [_vm._v("MBL Upload")]), _vm._v(" "), (_vm.$sessionsStorage.get('sendManifest_ffFclallModuleId')) ? _c('multi-file-uploader', {
    style: ("height: 79px;    background: darkgray;    width: 300px;"),
    attrs: {
      "documentName": 'Liner BL',
      "otherDocName": 'Liner BL',
      "folderName": 'Doc Library',
      "accept": '*',
      "assign_no": _vm.$sessionsStorage.get('JOBSERIES'),
      "multiple": false,
      "state": Boolean(_vm.singleUpload),
      "fileAllModuleId": _vm.$sessionsStorage.get('sendManifest_ffFclallModuleId')
    },
    model: {
      value: (_vm.singleUpload),
      callback: function($$v) {
        _vm.singleUpload = $$v
      },
      expression: "singleUpload"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$sessionsStorage.get('sendManifest_ffFclallModuleId')) ? _c('span', [_vm._v("Choose a file or drop it\n                  above...")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMBLList.linerBLupload))])], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    staticClass: "ml-2",
    attrs: {
      "md": "4"
    }
  }, [_c('b-button', {
    staticClass: "smbutnWidth mt-3",
    attrs: {
      "disabled": _vm.MBLFlag == true ? true : false,
      "variant": "primary",
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.saveMBL
    }
  }, [_vm._v("Save MBL")])], 1)], 1) : _c('b-row', [(_vm.MBLList.length > 0) ? _c('table', {
    staticClass: "table table-sm table-bordered"
  }, [_c('tbody', {
    staticStyle: {
      "background": "white"
    }
  }, [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SN.")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Shipment Type")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("BL Type")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Liner Freght Terms")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("MBL Number")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("PDF")])]), _vm._v(" "), _vm._l((_vm.MBLList), function(itm, idx) {
    return _c('tr', {
      key: idx
    }, [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(idx + 1))]), _vm._v(" "), _c('td', [(itm.bl_shipment_type) ? _c('span', [_vm._v(_vm._s(itm.bl_shipment_type))]) : _vm._e()]), _vm._v(" "), _c('td', [(itm.blType) ? _c('span', [_vm._v(_vm._s(itm.blType))]) : _vm._e()]), _vm._v(" "), _c('td', [(itm.blType) ? _c('span', [_vm._v(_vm._s(itm.frghtTermsLiner))]) : _vm._e()]), _vm._v(" "), _c('td', [(itm.blType) ? _c('span', [_vm._v(_vm._s(itm.linerBLNumber))]) : _vm._e()]), _vm._v(" "), _c('td', [(itm.linerBLupload) ? _c('span', [_c('b-button', {
      staticClass: "text-danger",
      staticStyle: {
        "font-size": "0.675rem"
      },
      attrs: {
        "variant": "outline-warning",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.PrintNote(
            itm.linerBLupload,
            _vm.ffExportDetail.ffExportFclSeries
          )
        }
      }
    }, [_vm._v("PDF")])], 1) : _vm._e()])])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "lg": "5"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "2"
    }
  }, [(_vm.lineADDManifestationModalArray.length > 0) ? _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "size": "sm",
      "variant": "primary",
      "id": "addButtonLoaderSB"
    },
    on: {
      "click": function($event) {
        _vm.MBLFlag ||
          (_vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' &&
            _vm.$sessionsStorage.get('cust_username') == 'Admin') ?
          _vm.addAddManifestationDetail() :
          _vm.checkMBLDetails()
      }
    }
  }, [_vm._v("Save & Submit\n                ")]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderSB"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "5"
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "popMailAfter",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c97824a6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/freightForwarding/ffManifestation.vue
// module id = 2859
// module chunks = 0